import { CustomMenu } from './CustomMenu';
import AddCompanyModal from './AddCompanyModal';
export const AddCompanyMenu = (props, callbacks = {}) =>
  CustomMenu(
    props,
    AddCompanyModal,
    {
      defaultCompany: props.selectProps.inputValue,
      afterCompanyAdded: callbacks.onCompanyAdded || (() => {}),
    },
    '+ Add Company'
  );
